import { env } from "@/env";

import { isSegmentRewritable } from "./isSegmentRewritable";

const isAlreadyRewritten = (url: string, rewriteTarget: string) => {
  const prefix = `/${rewriteTarget.replace(/^\/+|\/+$/g, "")}`;
  return url === prefix || ["/", "?", "#"].some((separator) => url.startsWith(`${prefix}${separator}`));
};

// It accepts urls without locale and starting with a slash
// for example: "/shop", "/shop/product-category/product-url-key"
export const rewriteUrls = (url: string, locale: string) => {
  const rewriteConfig = env.rewriteUrlsConfig[locale];
  const specificRewriteConfig = env.specificUrlsRewriteConfig[locale];

  const urlsParts = url.split("/");
  const firstSegment = urlsParts[1];

  if (!firstSegment) return url;

  if (isSegmentRewritable(firstSegment)) {
    if (urlsParts.length <= 2 && specificRewriteConfig?.[firstSegment]) {
      return url.replace(firstSegment, specificRewriteConfig?.[firstSegment] || firstSegment);
    }
    const rewriteTarget = rewriteConfig?.[firstSegment];
    if (rewriteTarget && isAlreadyRewritten(url, rewriteTarget)) {
      return url;
    }
    return url.replace(firstSegment, rewriteTarget || firstSegment);
  }
  return url;
};
